/**
 * Internal dependencies
 */

import {
    CURRENT_USER_RECEIVE,
    SET_PRIMARY_PAYMENT_SOURCE_ID,
    CURRENT_USER_CHARGEBEE_CUSTOMER_RECEIVE,
} from 'state/action-types';
import cscom from 'lib/customer-site-api';

export const setCurrentUser = (user) => {
    return {
        type: CURRENT_USER_RECEIVE,
        user,
    };
};

export const requestChargebeeCustomer = () => (dispatch) => {
    return cscom
        .user()
        .retrieveChargebeeCustomer()
        .then((customer) => {
            dispatch({
                type: CURRENT_USER_CHARGEBEE_CUSTOMER_RECEIVE,
                payload: { customer },
            });
            return customer;
        })
        .catch((error) => {
            throw error;
        });
};

export const setPrimaryPaymentSourceId = (primaryPaymentSourceId) => ({
    type: SET_PRIMARY_PAYMENT_SOURCE_ID,
    payload: { primaryPaymentSourceId },
});
